import React from 'react';
import { Slide, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import './reactToastifyOverrides.css';

export const NotificationContainer = () => (
  <ToastContainer position="top-center" hideProgressBar transition={Slide} />
);
